module.exports = __webpack_public_path__ + "img/arrow_left_circle.a259be42.svg";